module.exports = __webpack_public_path__ + "img/gaji_bulanan.a13e264d.png";